module.exports = __webpack_public_path__ + "static/media/biden.e3935b61.png";